import { radioStyles as fastSegmentedItemStyles } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
export const foundationSegmentedItemStyles = (context, definition) => css `
  ${fastSegmentedItemStyles(context, definition)}
  :host {
    padding: calc(var(--design-unit) * 2px) calc(var(--design-unit) * 4px);
    border: calc(var(--stroke-width) * 1px) solid var(--neutral-stroke-rest);
    cursor: pointer;
  }

  :host([aria-checked='true']) {
    background: var(--accent-foreground-rest);
  }
`;
